const getToastStyle = type => {
  switch (type) {
    case "success":
      return ["bg-light-green border-dark-green", "CheckCircle", "dark-green"];
    case "info":
      return ["bg-medium-fill-blue border-action-blue", "InfoCircle", "action-blue"];
    case "error":
      return ["bg-light-red border-dark-red", "CrossCircle", "red"];
    case "warning":
      return ["bg-light-yellow border-yellow", "Warning", "yellow"];
    case "system-alert-banner":
      return ["bg-orange", "InfoCircle", "brand-blue"];
    default:
      return ["bg-gray-light border-gray", "gray"];
  }
};
export default getToastStyle;
//# sourceMappingURL=getToastStyle.js.map